module.exports = __webpack_public_path__ + "static/media/brush_7.web.574b6dde.png";